export function addMouseOverListeners(container, itemSelector) {
    container.addEventListener('mouseover', debounce((event) => {
        const targetElement = event.target.closest(itemSelector);
        if (targetElement && container.contains(targetElement)) {
            this.updatePageNumberAndHistory(targetElement);
        }
    }, 100));
}